import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { Link } from "react-router-dom";
import { Button, Grid, Paper } from "@material-ui/core";

import DescriptionComponent from "../../descriptionComponent";

import { withStyles } from "@material-ui/core/styles";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import LabelForm from "../../../partials/labelForm";
import TextForm from "../../../partials/textForm";
import { formatDatetime } from "../../../utils/setting";
import PriceFormat from "../../../partials/priceFormat";
const styles = (theme) => ({
  paper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    padding: theme.spacing(2),
  },
  inputType: {
    height: "unset",
  },
  textField: {
    width: "100%",
  },
  buttonOnRow: {
    minWidth: "max-content",
    marginRight: "6px",
    marginTop: "6px",
  },
});
class EditUserVoucher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: JSON.parse(JSON.stringify(this.props.data || {})),
      times: this.props.data ? this.props.data.times : 0,
      checked: false,
    };
  }
  componentDidMount = () => {
    this.props.getListBranch();
  };
  handleInputChange = (event) => {
    let data = this.state.data;
    data[event.target.name] = event.target.value;
    this.setState(data);
  };
  handleChangeSwitch = (e) => {
    this.setState({
      checked: e.target.checked,
    });
  };
  handleSubComponentChange = (name, value) => {
    let data = this.state.data;
    data[name] = value;
    this.setState({ data });
  };
  render() {
    const { classes, t, match, listBranch } = this.props;
    const { data } = this.state;
    let membercard = data && data.memberCard;
    return (
      <Paper className={classes.paper}>
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4} md={4}>
            <LabelForm label={t("user_membercard_time_send_to_customer")} />
            <TextForm label={formatDatetime(data.createdAt)} />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <LabelForm label={t("user_membercard_time_to_use_card")} />
            <TextForm
              label={
                data.memberCard &&
                data.memberCard.expiredDays === Number.MAX_SAFE_INTEGER
                  ? t("membercard_un_specified")
                  : data.memberCard && data.memberCard.expiredDays
                  ? data.memberCard.expiredDays
                  : t("membercard_un_specified")
              }
            />
          </Grid>
          <Grid container item xs={12} sm={4} md={4} justify="flex-end">
            <div>
              <Link
                to={{
                  pathname: `/order/detail/${data.orderCode}`,
                  state: { prevPath: match.url },
                }}
              >
                <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  className={classes.buttonOnRow}
                >
                  {t("user_membercard_detail_order")}
                </Button>
              </Link>
              <Link
                to={`/promotion/userMembercard/detail?_id=${data.memberCardCode}&&countryCode=${data.countryCode}&&mobile=${data.mobile}`}
              >
                <Button
                  size="small"
                  color="primary"
                  variant="outlined"
                  className={classes.buttonOnRow}
                >
                  {t("user_membercard_history_membercard")}
                </Button>
              </Link>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <LabelForm label={t("user_membercard_value_to_use")} />
            <PriceFormat value={data.memberCard && data.memberCard.value} />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <LabelForm label={t("user_membercard_price_to_buy")} />
            <PriceFormat value={data.memberCard && data.memberCard.price} />
            {/* <TextForm label={data.memberCard && data.memberCard.price} /> */}
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <LabelForm
              label={t("user_membercard_max_number_of_times_to_use")}
            />
            <TextForm
              label={
                data.memberCard &&
                data.memberCard.times === Number.MAX_SAFE_INTEGER
                  ? t("membercard_un_specified")
                  : data.memberCard && data.memberCard.times
                  ? data.memberCard.times
                  : t("membercard_un_specified")
              }
            />
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <LabelForm label={t("user_membercard_used_number_of_times")} />
            <TextForm label={data.usingTimes} />
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <LabelForm label={t("user_membercard_membercardId")} />
            <TextForm label={data.memberCardId} />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <LabelForm label={t("booking_listbooking_tablehead_branch")} />
            {membercard.forAll ? (
              <TextForm label={t("listOrder_apply_for_all_branches")} />
            ) : (
              membercard.arrBranch.map((e) => {
                let branch = listBranch.find((ele) => ele.branchCode === e);
                if (branch) return <TextForm label={branch.branchName} />;
              })
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <LabelForm label={t("user_membercard_short_description")} />
            <TextForm
              label={data.memberCard && data.memberCard.shortDescription}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <DescriptionComponent
              onRef={(id) => (this.DescriptionComponent = id)}
              title={t("user_membercard_description")}
              handleSubComponentChange={this.handleSubComponentChange}
              description={data.memberCard && data.memberCard.description}
            />
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

EditUserVoucher.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  listBranch: state.serviceBranch.listBranch,
});

const mapDispatch = (dispatch) => ({
  getListBranch: dispatch.serviceBranch.getListBranch,
  updateTimesUserVoucher: dispatch.userVouchers.updateTimesUserVoucher,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(EditUserVoucher)
  )
);
